import React from 'react';

interface InfoFieldProps {
  label: string;
  value: string | React.ReactNode;
  className?: string;
  valueClassName?: string;
}

/**
 * Reusable info field component for displaying label-value pairs in print pages
 * Provides consistent styling across all print sections
 * Supports both string values and ReactNode for complex content
 */
export const InfoField = ({ label, value, className = '', valueClassName = '' }: InfoFieldProps) => {
  const isString = typeof value === 'string';

  return (
    <div className={`mb-1 p-[2px] ${className}`}>
      <span className="font-bold text-[#4E5155] text-[15px] print:text-[13px]">{label} : </span>
      {isString ? (
        <span className={`text-[#4E5155] text-[15px]  ${valueClassName}`}>{value}</span>
      ) : (
        value
      )}
    </div>
  );
};
